'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const CircularitySecondLifeIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M23.0221 4.3939C21.9073 2.85558 19.9455 2 17.4651 2C17.0417 2 16.6096 2.01729 16.1775 2.06914V3.46054C16.6182 3.40869 17.0503 3.37412 17.4651 3.37412C18.8911 3.37412 20.8183 3.69388 21.9073 5.18899C22.9011 6.58039 22.8752 8.61133 21.8295 10.9102C21.2764 12.1287 20.4727 13.3386 19.4702 14.4708C18.4677 15.6202 17.2664 16.7005 15.9182 17.6598C12.8502 19.8463 9.43649 21.0994 6.54997 21.0994C5.124 21.0994 3.19678 20.7883 2.10785 19.2845C1.10535 17.9018 1.13128 15.8708 2.18563 13.572C2.34119 13.2177 2.53132 12.8806 2.72145 12.5263H1.1572C1.07078 12.6818 1.00164 12.8374 0.932505 12.993C-0.329265 15.7585 -0.311981 18.282 0.993001 20.0883C2.10785 21.6352 4.07829 22.4822 6.54997 22.4822C9.71304 22.4822 13.4206 21.134 16.7133 18.7833C19.6084 16.7178 21.8641 14.1251 23.074 11.4719C24.3271 8.70639 24.3098 6.1915 23.0135 4.37663L23.0221 4.3939Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.30667 10.4868L5.47815 14.3153L9.30667 18.1438L10.2832 17.1673L8.16589 15.0499H14.129C16.3415 15.0499 18.139 13.2523 18.139 11.0399C18.139 8.82748 16.3415 7.02989 14.129 7.02989H13.7401V6.64099C13.7401 4.42857 11.9425 2.63098 9.73014 2.63098C7.51772 2.63098 5.72013 4.42857 5.72013 6.64099V10.409H7.1029V6.64099C7.1029 5.18909 8.27824 4.01373 9.73014 4.01373C11.182 4.01373 12.3574 5.18909 12.3574 6.64099V8.404H14.1204C15.5723 8.404 16.7476 9.57936 16.7476 11.0313C16.7476 12.4832 15.5723 13.6585 14.1204 13.6585H8.05354L10.2659 11.4461L9.28939 10.4695L9.30667 10.4868Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpCircularitySecondLifeIcon = forwardRef(CircularitySecondLifeIcon);

export { VpCircularitySecondLifeIcon as default };
